import React from 'react';
import { MdCheckBoxOutlineBlank, MdMoreHoriz } from 'react-icons/md';

import Skeleton from '@material-ui/lab/Skeleton';

import colors from '~/styles/colors';

import { TableSkeletonProps } from '../interface';
import { CheckboxColumn, FirstColumn, RowData } from '../styles';

function TableRowSkeleton({
  numberOfRows,
  columns,
  hasMenu,
  hasSelectedEntities,
  hasBorderColor,
}: TableSkeletonProps) {
  return (
    <>
      {Array.from(Array(numberOfRows)).map((_, index) => (
        <RowData key={`skeleton-${index}`}>
          {hasSelectedEntities && (
            <CheckboxColumn>
              <MdCheckBoxOutlineBlank
                size={24}
                color="#b4b4b4"
                style={{ cursor: 'default' }}
              />
            </CheckboxColumn>
          )}
          {hasBorderColor && <FirstColumn borderColor={colors.gray} />}
          {columns.map(
            (column) =>
              column.condition !== false && (
                <td>
                  <Skeleton animation="wave" height={51} width="100%" />
                </td>
              ),
          )}
          {hasMenu && (
            <td>
              <MdMoreHoriz
                size={24}
                color={colors.gray}
                style={{ cursor: 'default' }}
              />
            </td>
          )}
        </RowData>
      ))}
    </>
  );
}

export default TableRowSkeleton;
